// Primary 4 Chinese Data - Part 1
// Based on Primary Chinese P4 Topics.txt

export const p4DataPart1 = {
  title: "小學四年級中文學習",
  description: "專為小學四年級學生設計的中文學習內容，進一步提升語文能力和寫作技巧",
  objectives: "提升語文運用能力，培養寫作思維，掌握更複雜的語法結構",
  focus: "重點學習分號、多義詞、段義理解等進階語法，以及更豐富的文體閱讀理解",
  
  readingTypes: [
    "生活故事", "說明事物", "抒情文", "書信", "記事", "名人故事",
    "描寫事物", "描寫動物", "通告", "遊記", "描寫植物", "描寫人物", "週記", "便條"
  ],
  
  languageUsage: [
    {
      title: "分號",
      description: "學習分號的用法，掌握複雜句子的標點符號",
      sampleQuestions: [
        {
          question: "選擇正確的標點符號：我喜歡讀書（ ）他喜歡運動。",
          answer: "；",
          explanation: "分號用於分隔兩個相關但獨立的句子。"
        },
        {
          question: "選擇正確的標點符號：春天來了（ ）花兒開了。",
          answer: "；",
          explanation: "分號用於分隔兩個並列的句子。"
        },
        {
          question: "選擇正確的標點符號：小明很聰明（ ）小華很勤奮。",
          answer: "；",
          explanation: "分號用於分隔兩個對比的句子。"
        },
        {
          question: "選擇正確的標點符號：我喜歡紅色（ ）他喜歡藍色。",
          answer: "；",
          explanation: "分號用於分隔兩個選擇的句子。"
        },
        {
          question: "選擇正確的標點符號：我喜歡讀書（ ）他喜歡畫畫。",
          answer: "；",
          explanation: "分號用於分隔兩個並列的句子。"
        },
        {
          question: "選擇正確的標點符號：我喜歡唱歌（ ）他喜歡跳舞。",
          answer: "；",
          explanation: "分號用於分隔兩個並列的句子。"
        },
        {
          question: "選擇正確的標點符號：我喜歡游泳（ ）他喜歡跑步。",
          answer: "；",
          explanation: "分號用於分隔兩個並列的句子。"
        },
        {
          question: "選擇正確的標點符號：我喜歡畫畫（ ）他喜歡寫字。",
          answer: "；",
          explanation: "分號用於分隔兩個並列的句子。"
        },
        {
          question: "選擇正確的標點符號：我喜歡看書（ ）他喜歡看電視。",
          answer: "；",
          explanation: "分號用於分隔兩個並列的句子。"
        },
        {
          question: "選擇正確的標點符號：我喜歡聽音樂（ ）他喜歡聽故事。",
          answer: "；",
          explanation: "分號用於分隔兩個並列的句子。"
        }
      ]
    },
    {
      title: "多義詞",
      description: "學習多義詞的不同含義，掌握詞語的語境用法",
      sampleQuestions: [
        {
          question: "選擇正確的含義：『打』在『打電話』中的意思是（ ）",
          answer: "撥打",
          explanation: "『打』在這裡是撥打的意思。"
        },
        {
          question: "選擇正確的含義：『打』在『打籃球』中的意思是（ ）",
          answer: "玩",
          explanation: "『打』在這裡是玩的意思。"
        },
        {
          question: "選擇正確的含義：『打』在『打掃』中的意思是（ ）",
          answer: "清潔",
          explanation: "『打』在這裡是清潔的意思。"
        },
        {
          question: "選擇正確的含義：『打』在『打雷』中的意思是（ ）",
          answer: "發出",
          explanation: "『打』在這裡是發出的意思。"
        },
        {
          question: "選擇正確的含義：『打』在『打針』中的意思是（ ）",
          answer: "注射",
          explanation: "『打』在這裡是注射的意思。"
        },
        {
          question: "選擇正確的含義：『看』在『看書』中的意思是（ ）",
          answer: "閱讀",
          explanation: "『看』在這裡是閱讀的意思。"
        },
        {
          question: "選擇正確的含義：『看』在『看電影』中的意思是（ ）",
          answer: "觀看",
          explanation: "『看』在這裡是觀看的意思。"
        },
        {
          question: "選擇正確的含義：『看』在『看病』中的意思是（ ）",
          answer: "診治",
          explanation: "『看』在這裡是診治的意思。"
        },
        {
          question: "選擇正確的含義：『看』在『看門』中的意思是（ ）",
          answer: "看守",
          explanation: "『看』在這裡是看守的意思。"
        },
        {
          question: "選擇正確的含義：『看』在『看中』中的意思是（ ）",
          answer: "喜歡",
          explanation: "『看』在這裡是喜歡的意思。"
        }
      ]
    },
    {
      title: "段義理解",
      description: "學習段落意思的理解，掌握段落的主旨和中心思想",
      sampleQuestions: [
        {
          question: "這段話的主要意思是（ ）：春天來了，花兒開了，鳥兒唱歌了。",
          answer: "春天很美麗",
          explanation: "這段話描述了春天的美麗景象。"
        },
        {
          question: "這段話的主要意思是（ ）：小明很聰明，他學習很認真，成績很好。",
          answer: "小明學習很好",
          explanation: "這段話說明了小明的學習情況。"
        },
        {
          question: "這段話的主要意思是（ ）：這本書很有趣，內容很豐富，我很喜歡。",
          answer: "這本書很好",
          explanation: "這段話表達了對這本書的喜愛。"
        },
        {
          question: "這段話的主要意思是（ ）：公園裡有很多人，有的在散步，有的在跑步。",
          answer: "公園很熱鬧",
          explanation: "這段話描述了公園的熱鬧景象。"
        },
        {
          question: "這段話的主要意思是（ ）：媽媽很辛苦，每天要做飯，要洗衣服。",
          answer: "媽媽很辛苦",
          explanation: "這段話說明了媽媽的辛苦。"
        },
        {
          question: "這段話的主要意思是（ ）：這隻貓很可愛，毛很軟，眼睛很亮。",
          answer: "這隻貓很可愛",
          explanation: "這段話描述了貓的可愛特徵。"
        },
        {
          question: "這段話的主要意思是（ ）：這個蘋果很甜，很脆，很好吃。",
          answer: "這個蘋果很好吃",
          explanation: "這段話表達了對蘋果的喜愛。"
        },
        {
          question: "這段話的主要意思是（ ）：這個房間很大，很乾淨，很舒服。",
          answer: "這個房間很好",
          explanation: "這段話描述了房間的優點。"
        },
        {
          question: "這段話的主要意思是（ ）：這個故事很有趣，情節很精彩，我很喜歡。",
          answer: "這個故事很好",
          explanation: "這段話表達了對故事的喜愛。"
        },
        {
          question: "這段話的主要意思是（ ）：這個遊戲很好玩，規則很簡單，我很喜歡。",
          answer: "這個遊戲很好",
          explanation: "這段話表達了對遊戲的喜愛。"
        }
      ]
    },
    {
      title: "假設複句",
      description: "學習假設複句的結構，掌握假設句的表達方法",
      sampleQuestions: [
        {
          question: "選擇正確的假設詞：如果下雨，（ ）我就不出門。",
          answer: "就",
          explanation: "『就』是假設複句的連接詞。"
        },
        {
          question: "選擇正確的假設詞：如果我有時間，（ ）我就去看電影。",
          answer: "就",
          explanation: "『就』是假設複句的連接詞。"
        },
        {
          question: "選擇正確的假設詞：如果我有錢，（ ）我就買新書。",
          answer: "就",
          explanation: "『就』是假設複句的連接詞。"
        },
        {
          question: "選擇正確的假設詞：如果我有空，（ ）我就去公園。",
          answer: "就",
          explanation: "『就』是假設複句的連接詞。"
        },
        {
          question: "選擇正確的假設詞：如果我有機會，（ ）我就去旅行。",
          answer: "就",
          explanation: "『就』是假設複句的連接詞。"
        },
        {
          question: "選擇正確的假設詞：如果我有能力，（ ）我就幫助別人。",
          answer: "就",
          explanation: "『就』是假設複句的連接詞。"
        },
        {
          question: "選擇正確的假設詞：如果我有條件，（ ）我就學習新技能。",
          answer: "就",
          explanation: "『就』是假設複句的連接詞。"
        },
        {
          question: "選擇正確的假設詞：如果我有興趣，（ ）我就參加活動。",
          answer: "就",
          explanation: "『就』是假設複句的連接詞。"
        },
        {
          question: "選擇正確的假設詞：如果我有需要，（ ）我就買東西。",
          answer: "就",
          explanation: "『就』是假設複句的連接詞。"
        },
        {
          question: "選擇正確的假設詞：如果我有想法，（ ）我就寫下來。",
          answer: "就",
          explanation: "『就』是假設複句的連接詞。"
        }
      ]
    },
    {
      title: "量詞",
      description: "學習各種量詞的用法，掌握正確的量詞搭配",
      sampleQuestions: [
        {
          question: "選擇正確的量詞：一（ ）書",
          answer: "本",
          explanation: "『本』是用來計算書本的量詞。"
        },
        {
          question: "選擇正確的量詞：一（ ）花",
          answer: "朵",
          explanation: "『朵』是用來計算花朵的量詞。"
        },
        {
          question: "選擇正確的量詞：一（ ）筆",
          answer: "支",
          explanation: "『支』是用來計算筆的量詞。"
        },
        {
          question: "選擇正確的量詞：一（ ）桌子",
          answer: "張",
          explanation: "『張』是用來計算桌子的量詞。"
        },
        {
          question: "選擇正確的量詞：一（ ）椅子",
          answer: "把",
          explanation: "『把』是用來計算椅子的量詞。"
        },
        {
          question: "選擇正確的量詞：一（ ）蘋果",
          answer: "個",
          explanation: "『個』是用來計算蘋果的量詞。"
        },
        {
          question: "選擇正確的量詞：一（ ）魚",
          answer: "條",
          explanation: "『條』是用來計算魚的量詞。"
        },
        {
          question: "選擇正確的量詞：一（ ）貓",
          answer: "隻",
          explanation: "『隻』是用來計算動物的量詞。"
        },
        {
          question: "選擇正確的量詞：一（ ）車",
          answer: "輛",
          explanation: "『輛』是用來計算車輛的量詞。"
        },
        {
          question: "選擇正確的量詞：一（ ）房子",
          answer: "間",
          explanation: "『間』是用來計算房子的量詞。"
        }
      ]
    }
  ]
};

// Primary 4 Chinese Data - Part 2
export const p4DataPart2 = {
  languageUsage: [
    {
      title: "發義詞",
      description: "學習發義詞的用法，掌握詞語的引申意義",
      sampleQuestions: [
        {
          question: "選擇正確的發義詞：『火』除了指火焰，還可以指（ ）",
          answer: "憤怒",
          explanation: "『火』可以引申為憤怒的意思。"
        },
        {
          question: "選擇正確的發義詞：『水』除了指液體，還可以指（ ）",
          answer: "水平",
          explanation: "『水』可以引申為水平的意思。"
        },
        {
          question: "選擇正確的發義詞：『山』除了指山脈，還可以指（ ）",
          answer: "困難",
          explanation: "『山』可以引申為困難的意思。"
        },
        {
          question: "選擇正確的發義詞：『海』除了指海洋，還可以指（ ）",
          answer: "廣闊",
          explanation: "『海』可以引申為廣闊的意思。"
        },
        {
          question: "選擇正確的發義詞：『天』除了指天空，還可以指（ ）",
          answer: "自然",
          explanation: "『天』可以引申為自然的意思。"
        },
        {
          question: "選擇正確的發義詞：『地』除了指土地，還可以指（ ）",
          answer: "地方",
          explanation: "『地』可以引申為地方的意思。"
        },
        {
          question: "選擇正確的發義詞：『人』除了指人類，還可以指（ ）",
          answer: "人才",
          explanation: "『人』可以引申為人才的意思。"
        },
        {
          question: "選擇正確的發義詞：『心』除了指心臟，還可以指（ ）",
          answer: "內心",
          explanation: "『心』可以引申為內心的意思。"
        },
        {
          question: "選擇正確的發義詞：『手』除了指手部，還可以指（ ）",
          answer: "技能",
          explanation: "『手』可以引申為技能的意思。"
        },
        {
          question: "選擇正確的發義詞：『眼』除了指眼睛，還可以指（ ）",
          answer: "眼光",
          explanation: "『眼』可以引申為眼光的意思。"
        }
      ]
    },
    {
      title: "古詩",
      description: "學習古詩的理解，掌握古詩的意境和表達方法",
      sampleQuestions: [
        {
          question: "『床前明月光，疑是地上霜』這首詩描寫的是（ ）",
          answer: "月光",
          explanation: "這首詩描寫了明亮的月光。"
        },
        {
          question: "『春眠不覺曉，處處聞啼鳥』這首詩描寫的是（ ）",
          answer: "春天",
          explanation: "這首詩描寫了春天的景象。"
        },
        {
          question: "『鋤禾日當午，汗滴禾下土』這首詩描寫的是（ ）",
          answer: "農民",
          explanation: "這首詩描寫了農民勞動的辛苦。"
        },
        {
          question: "『白日依山盡，黃河入海流』這首詩描寫的是（ ）",
          answer: "自然",
          explanation: "這首詩描寫了自然的壯麗景象。"
        },
        {
          question: "『遠看山有色，近聽水無聲』這首詩描寫的是（ ）",
          answer: "山水",
          explanation: "這首詩描寫了山水的美麗。"
        },
        {
          question: "『千山鳥飛絕，萬徑人蹤滅』這首詩描寫的是（ ）",
          answer: "寂靜",
          explanation: "這首詩描寫了寂靜的環境。"
        },
        {
          question: "『孤舟蓑笠翁，獨釣寒江雪』這首詩描寫的是（ ）",
          answer: "漁夫",
          explanation: "這首詩描寫了漁夫釣魚的情景。"
        },
        {
          question: "『小荷才露尖尖角，早有蜻蜓立上頭』這首詩描寫的是（ ）",
          answer: "荷花",
          explanation: "這首詩描寫了荷花的嬌嫩。"
        },
        {
          question: "『停車坐愛楓林晚，霜葉紅於二月花』這首詩描寫的是（ ）",
          answer: "楓葉",
          explanation: "這首詩描寫了楓葉的美麗。"
        },
        {
          question: "『兩個黃鸝鳴翠柳，一行白鷺上青天』這首詩描寫的是（ ）",
          answer: "鳥類",
          explanation: "這首詩描寫了鳥類的美麗。"
        }
      ]
    },
    {
      title: "承接複句/重組句子",
      description: "學習承接複句的結構，掌握句子的重組方法",
      sampleQuestions: [
        {
          question: "選擇正確的連接詞：我喜歡讀書，（ ）我也喜歡畫畫。",
          answer: "而且",
          explanation: "『而且』用來連接兩個並列的意思。"
        },
        {
          question: "選擇正確的連接詞：小明很聰明，（ ）他很勤奮。",
          answer: "而且",
          explanation: "『而且』用來連接兩個並列的意思。"
        },
        {
          question: "選擇正確的連接詞：我喜歡紅色，（ ）我也喜歡藍色。",
          answer: "而且",
          explanation: "『而且』用來連接兩個並列的意思。"
        },
        {
          question: "選擇正確的連接詞：這本書很有趣，（ ）它很有用。",
          answer: "而且",
          explanation: "『而且』用來連接兩個並列的意思。"
        },
        {
          question: "選擇正確的連接詞：小華很可愛，（ ）她很聰明。",
          answer: "而且",
          explanation: "『而且』用來連接兩個並列的意思。"
        },
        {
          question: "重組句子：我 / 喜歡 / 讀書",
          answer: "我喜歡讀書。",
          explanation: "按照主語+謂語+賓語的順序重組句子。"
        },
        {
          question: "重組句子：小明 / 在 / 公園 / 玩",
          answer: "小明在公園玩。",
          explanation: "按照主語+介詞+地點+謂語的順序重組句子。"
        },
        {
          question: "重組句子：媽媽 / 做 / 飯",
          answer: "媽媽做飯。",
          explanation: "按照主語+謂語+賓語的順序重組句子。"
        },
        {
          question: "重組句子：我 / 和 / 朋友 / 一起 / 玩",
          answer: "我和朋友一起玩。",
          explanation: "按照主語+連詞+賓語+副詞+謂語的順序重組句子。"
        },
        {
          question: "重組句子：老師 / 教 / 我們 / 中文",
          answer: "老師教我們中文。",
          explanation: "按照主語+謂語+間接賓語+直接賓語的順序重組句子。"
        }
      ]
    },
    {
      title: "時間副詞/詞義辨析",
      description: "學習時間副詞的用法，掌握詞義的辨析方法",
      sampleQuestions: [
        {
          question: "選擇正確的時間副詞：我（ ）讀書",
          answer: "每天",
          explanation: "『每天』表示時間的頻率。"
        },
        {
          question: "選擇正確的時間副詞：他（ ）起床",
          answer: "早上",
          explanation: "『早上』表示時間的時段。"
        },
        {
          question: "選擇正確的時間副詞：她（ ）睡覺",
          answer: "晚上",
          explanation: "『晚上』表示時間的時段。"
        },
        {
          question: "選擇正確的時間副詞：我（ ）吃飯",
          answer: "中午",
          explanation: "『中午』表示時間的時段。"
        },
        {
          question: "選擇正確的時間副詞：他（ ）回家",
          answer: "下午",
          explanation: "『下午』表示時間的時段。"
        },
        {
          question: "選擇正確的詞義：『美麗』和『漂亮』的區別是（ ）",
          answer: "美麗更正式",
          explanation: "『美麗』比『漂亮』更正式。"
        },
        {
          question: "選擇正確的詞義：『聰明』和『智慧』的區別是（ ）",
          answer: "智慧更深刻",
          explanation: "『智慧』比『聰明』更深刻。"
        },
        {
          question: "選擇正確的詞義：『快樂』和『開心』的區別是（ ）",
          answer: "快樂更持久",
          explanation: "『快樂』比『開心』更持久。"
        },
        {
          question: "選擇正確的詞義：『勤奮』和『努力』的區別是（ ）",
          answer: "勤奮更習慣",
          explanation: "『勤奮』比『努力』更習慣。"
        },
        {
          question: "選擇正確的詞義：『安靜』和『寧靜』的區別是（ ）",
          answer: "寧靜更優雅",
          explanation: "『寧靜』比『安靜』更優雅。"
        }
      ]
    },
    {
      title: "連詞",
      description: "學習連詞的用法，掌握句子的連接方法",
      sampleQuestions: [
        {
          question: "選擇正確的連詞：我喜歡讀書（ ）畫畫",
          answer: "和",
          explanation: "『和』用來連接兩個並列的名詞。"
        },
        {
          question: "選擇正確的連詞：我喜歡紅色（ ）藍色",
          answer: "和",
          explanation: "『和』用來連接兩個並列的名詞。"
        },
        {
          question: "選擇正確的連詞：我喜歡唱歌（ ）跳舞",
          answer: "和",
          explanation: "『和』用來連接兩個並列的動詞。"
        },
        {
          question: "選擇正確的連詞：我喜歡游泳（ ）跑步",
          answer: "和",
          explanation: "『和』用來連接兩個並列的動詞。"
        },
        {
          question: "選擇正確的連詞：我喜歡看書（ ）看電視",
          answer: "和",
          explanation: "『和』用來連接兩個並列的動詞短語。"
        },
        {
          question: "選擇正確的連詞：我喜歡聽音樂（ ）聽故事",
          answer: "和",
          explanation: "『和』用來連接兩個並列的動詞短語。"
        },
        {
          question: "選擇正確的連詞：我喜歡吃蘋果（ ）吃橙子",
          answer: "和",
          explanation: "『和』用來連接兩個並列的動詞短語。"
        },
        {
          question: "選擇正確的連詞：我喜歡玩遊戲（ ）玩玩具",
          answer: "和",
          explanation: "『和』用來連接兩個並列的動詞短語。"
        },
        {
          question: "選擇正確的連詞：我喜歡寫字（ ）畫畫",
          answer: "和",
          explanation: "『和』用來連接兩個並列的動詞。"
        },
        {
          question: "選擇正確的連詞：我喜歡讀書（ ）寫作",
          answer: "和",
          explanation: "『和』用來連接兩個並列的動詞。"
        }
      ]
    }
  ]
}; 